import Bugsnag from '@bugsnag/js'
import { NODE_ENV } from './utils'
import { isError } from 'lodash'

const convertGraphqlError = ({ errors }, { query }) => {
  if (
    // graphql error
    Array.isArray(errors)
  ) {
    const { message, path } = errors[0]
    const error_path = path && path[0] !== query && path[0]

    return new Error(
      [query, message, error_path, '(graphql error)']
        .filter((item) => item)
        .join(' / ')
    )
  }

  return new Error('convertGraphqlError: unknown')
}

export const notifyBugsnag = (error, query) => {
  console.error(error) // eslint-disable-line

  if (NODE_ENV === 'development') return

  const shadow = isError(error) ? error : convertGraphqlError(error, { query })

  const { message } = shadow
  if (
    message.toLowerCase().includes('failed to fetch') ||
    message.toLowerCase().includes('network error') ||
    message.toLowerCase().includes('networkerror')
  ) {
    return
  }

  Bugsnag.leaveBreadcrumb('notifyBugsnag', { query, message }, 'error')
  Bugsnag.notify(shadow)
}

// Bewusst ohne den Netzwerkfehler-Filter von notifyBugsnag: ein
// fehlgeschlagener Dokument-Upload (auch "Failed to fetch" gegen S3) heisst,
// dass dem Unternehmen ein Dokument fehlt, und muss sichtbar werden.
export const notifyDocumentUploadFailure = (error, metadata = {}) => {
  console.error(error) // eslint-disable-line

  if (NODE_ENV === 'development') return

  const shadow = isError(error) ? error : new Error(String(error))

  Bugsnag.notify(shadow, (event) => {
    event.context = 'document-upload'
    event.groupingHash = `document-upload/${shadow.stage || 'unknown'}/${
      shadow.status || shadow.code || 'unknown'
    }`
    event.addMetadata('document_upload', {
      stage: shadow.stage,
      status: shadow.status,
      code: shadow.code,
      ...metadata
    })
  })
}
